import { render, staticRenderFns } from "./viewcheckoffs.vue?vue&type=template&id=48a5b4cd"
import script from "./viewcheckoffs.vue?vue&type=script&lang=js"
export * from "./viewcheckoffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports